<template>
  <navbar :show-navbar="showNavbar" style="background-color: white" :transparent="false">
    <!-- Added position and width style to fix brandlogo position -->
    <div class="navbar-wrapper" style="position: relative;width: 100%;">
      <div class="navbar-toggle" :class="{ toggled: $sidebar.showSidebar }" v-if="$route.meta.SHOW_MENU">
        <navbar-toggle-button @click.native="toggleSidebar"></navbar-toggle-button>
      </div>

      <n-button style="background: transparent; color: white; height: 1.375rem;box-shadow: none;" social icon round @click.native="goBack()" v-show="$route.meta.BACK_BUTTON">
        <i slot="label" class="now-ui-icons arrows-1_minimal-left" style="color:var(--color-primary)"></i>
      </n-button>
      <a class="navbar-brand" @click="goBack()" style="font-weight: 600">
        <span v-show="appHeaderText">{{ ($route.path == '/telemed') || ($route.path == '/postponedprescription') ? $t('message.Consultation') + " - " + $t(appHeaderText) : $t(appHeaderText) }}</span>
        <span v-show="!appHeaderText">{{ $t($route.name) }}</span>
      </a>
      <div v-if="myLocation && ['/home'].indexOf($route.path) > -1">
        <div style="font-size: x-small">
          <i class="now-ui-icons location_pin"></i>
          <span class="pl-1">{{ $t("message.Your Location") }}</span>
        </div>
        <div>{{ myLocation }}</div>
      </div>
      <div style="position:absolute;inset-inline-end: 0.5em;display:flex;height:100%;align-items: center;">
        <div v-if="(user && (user.roles.includes('doctor') || user.roles.includes('careCoordinator'))) && ($route.path != '/telemed' && $route.path != '/telemeddiscussion') && ($route.path != '/postponedprescription')">
          <n-switch style="text-" id="visibility" @click.native="toggleStatus()" color="green" onText="Online" offText="Offline" v-model="IS_AVAILABLE"></n-switch>
        </div>
        <div v-if="$route.path != '/telemed' && (!appointment || !appointment._id)" style="cursor: pointer;" @click="openEUPDF">
          <img v-if="!brandLogoMiniUrl && !appSettings.whiteLabelled" src="@/assets/img/carenation-logo.png" style="margin-inline-start:1em;height: 28px;filter: invert(0.5)" />
          <img v-if="brandLogoMiniUrl" :src="brandLogoMiniUrl" style="margin-inline-start:1em;height: 55px;" />
        </div>
      </div>
    </div>
    <!-- <button @click="toggleNavbar" class="navbar-toggler" type="button" data-toggle="collapse"
            data-target="#navigation"
            aria-controls="navigation-index" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-bar navbar-kebab"></span>
      <span class="navbar-toggler-bar navbar-kebab"></span>
      <span class="navbar-toggler-bar navbar-kebab"></span>
    </button>-->

    <template slot="navbar-menu">
      <!-- <form>
        <div class="input-group no-border">
          <fg-input placeholder="Search..." addon-right-icon="now-ui-icons ui-1_zoom-bold">
          </fg-input>
        </div>
      </form>-->

      <!-- <ul class="navbar-nav">
        <li class="nav-item">
          <a class="nav-link" href="#pablo">
            <i class="now-ui-icons media-2_sound-wave"></i>
            <p>
              <span class="d-lg-none d-md-block">Stats</span>
            </p>
          </a>
        </li>
        <drop-down tag="li"
                   position="right"
                   class="nav-item"
                   icon="now-ui-icons location_world">

          <a class="dropdown-item" href="#">Action</a>
          <a class="dropdown-item" href="#">Another action</a>
          <a class="dropdown-item" href="#">Something else here</a>
        </drop-down>

        <li class="nav-item">
          <a class="nav-link" href="#pablo">
            <i class="now-ui-icons users_single-02"></i>
            <p>
              <span class="d-lg-none d-md-block">Account</span>
            </p>
          </a>
        </li>
      </ul>-->
    </template>
  </navbar>
</template>
<script>
import { RouteBreadCrumb, Navbar, NavbarToggleButton } from "src/components";
import { CollapseTransition } from "vue2-transitions";
import { Switch } from "src/components";

export default {
  components: {
    RouteBreadCrumb,
    Navbar,
    NavbarToggleButton,
    CollapseTransition,
    [Switch.name]: Switch,
  },
  computed: {
    settings() {
      return this.$store.state.settings;
    },
    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    },
    myLocation() {
      return this.$store.state.myLocation;
    },
    appointment() {
      return this.$store.state.appointment;
    },
    appHeaderTextChanged() {
      return this.$store.state.appHeaderTextChanged;
    },
    appHeaderText() {
      return this.$store.state.appHeaderText;
    },
    brandLogoMiniUrl() {
      return this.$store.state.brandLogoMini;
    },
    userDetails() {
      return this.user.available;
    },
  },
  data() {
    return {
      activeNotifications: false,
      showNavbar: false,
      IS_AVAILABLE: true,
    };
  },
  // async beforeMount() {},
  async mounted() {
    if(this.settings && this.settings.brandLogoMini && this.settings.tenant) {
      let tenant = await this.$store.dispatch(
        "getTenant",
        this.settings.tenant
      );
      this.brandLogoMiniUrl = await this.$store.dispatch(
        "getBrandLogoMini",
        tenant.name
      );
    }
    this.$store.commit("setState", {
      stateName: "appHeaderText",
      stateValue: this.$route.name,
    });
  },
  methods: {
    openEUPDF() {
      window.open("/pdf/eu.pdf", '_blank');
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    toggleNavbar() {
      this.showNavbar = !this.showNavbar;
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    async toggleStatus() {
      this.$store.dispatch("updateAvailibility", {
        status: this.IS_AVAILABLE,
        _id: this.user._id,
      });

      if(this.user.status == "online") {
        this.user.status = "offline";
        socket.emit("leaveRoom", {
          type: "user",
          id: this.user._id,
        });
      } else {
        this.user.status = "online";
        socket.emit("joinRoom", {
          type: "user",
          id: this.user._id,
        });
      }
    },
    goBack() {
      if(this.$route.meta.BACK_BUTTON) {
        switch(this.$route.name) {
          case "/videos":
            this.$router.push("home");
            break;
          case "/prescription":
            this.$router.push("prescriptions");
            break;
          case "/questionnaire":
            this.$router.push("questionnaires");
            break;
          case "message.Attend Request":
            this.$router.push("carecohome");
            break;

          //Nurse
          case "message.Create Lab Order":
          case "message.Create Patient":
          case "message.Edit Patient":
          case "message.Vitals":
          case "message.Create New Appointment":
          case "message.Files History":
          case "message.Notes History":
            if(this.user && this.user.roles.includes("lab-operator")) {
              this.$router.push("/laboperatorhome");
            } else if(this.user.roles.includes("patient")) {
              this.$router.push("/patienthome");
            } else {
              this.$router.push("/nursehome");
            }
            break;
          case "message.Answer Questrionnaires":
          case "message.Answered Questrionnaire":
          case "message.Questionnaires":
            this.$router.back();
            break;
          case "message.Lab Order Details":
            if(this.user && this.user.roles.includes("lab-operator")) {
              this.$router.push("/laboperatorhome");
            } else if(this.user && this.user.roles.includes("lab-runner")) {
              this.$router.push("/labrunnerhome");
            } else if(this.user && this.user.roles.includes("nurse")) {
              this.$router.push("/nursehome");
            } else {
              this.$router.back();
            }
            break;
          //Patient
          case "message.Videos":
          case "message.Requested Checkups":
          case "message.Fitness":
            this.$router.push("/patienthome");
            break;
          case "message.Yoga":
            this.$router.push("/patienthome");
            break;
          case "message.Nutrition":
            this.$router.back();
            break;
          case "message.Request Health Checkup":
          case "message.Requested Health Checkup":
          case "message.Health Checkup Report":
            this.$router.back();
            break;
          case "message.Yoga Sets":
            this.$router.push("/yogavideos");
            break;
          case "message.Yoga Schedule":
            this.$router.push("/yogasets");
            break;
          case "message.reminders":
            this.$router.push("/patienthome");
            break;
          case "message.Book lab test":
            this.$router.push("/patienthome");
            break;
          case "message.Patient Home":
            this.$router.push("/patienthome");
            break;
          case "message.Workouts":
            this.$router.push("/fitnessvideos");
            break;
          case "message.Training":
            if(this.$store.state.trainingType == "yoga") {
              this.$router.push("/yogaschedule");
            } else {
              this.$router.push("/fitnessschedule");
            }
            break;
          case "message.Exercise":
            if(this.$store.state.trainingType == "yoga") {
              this.$router.push("/yogaschedule");
            } else {
              this.$router.push("/fitnessschedule");
            }
            break;
          case "message.Fitness Schedule":
            this.$router.push("/fitnesssets");
            break;
          default:
            this.$router.back();
        }
      }
    },
  },
  watch: {
    $route: function (to, from) {
      this.$store.commit("setState", {
        stateName: "appHeaderText",
        stateValue: to.name,
      });
    },
  },
};
</script>
<style scoped>
/deep/.bootstrap-switch-handle-on.bootstrap-switch-green {
  color: black;
}

.navbar {
  padding-top: 0;
}

.bootstrap-switch {
  margin-bottom: 0;
}

nav {
  /* background: -webkit-gradient(
    linear,
    left top,
    right top,
    from(var(--color-secondary1)),
    color-stop(60%, var(--color-secondary2)),
    to(var(--color-secondary3))
  );
  background: linear-gradient(
    to right,
    var(--color-secondary1) 0%,
    var(--color-secondary2) 60%,
    var(--color-secondary3) 100%
  ); */
  padding-bottom: 0em;
  position: fixed !important;
}
</style>
